import { Col, Container, Row } from "react-grid-system";
import { LayoutContainer, StyledLayout } from "./styles";
import { Header } from "../../components/Header/Header";
import { findAllByDisplayValue } from "@testing-library/react";
import { useStoreActions, useStoreState } from "../../store";
import { HiddenFlag } from "../../types/HiddenFlag";
import { useEffect } from "react";
import { HeaderMode } from "../../types/HeaderMode";

interface IProps {
  children: React.ReactNode;
  hideHeader?: boolean;
}

export const DefaultLayout: React.FC<IProps> = ({
  children,
  hideHeader,
}: IProps) => {
  const user = useStoreState((state) => state.user);

  const { setHeaderMode } = useStoreActions((actions) => actions.appSettings);

  useEffect(() => {
    if (
      (user.info.hidden & HiddenFlag.HiddenShopfloor) ===
      HiddenFlag.HiddenShopfloor
    ) {
      setHeaderMode(HeaderMode.None);
    }
  }, [user]);

  return (
    <StyledLayout>
      <Container fluid={true} id="layout-container">
        {user &&
        user.info &&
        (user.info.hidden & HiddenFlag.HiddenShopfloor) ===
          HiddenFlag.HiddenShopfloor ? (
          <>
            <Header />
            <div className="text-danger">
              <h1>Authentication Error: You don't have access</h1>
            </div>
          </>
        ) : (
          <>
            {hideHeader === true ? <></> : <Header />}
            <LayoutContainer>
              <div className="content-scrollable">{children}</div>
            </LayoutContainer>
          </>
        )}
        {/* {hideHeader === true ? <></> : <Header />}
        <LayoutContainer>
          <div className="content-scrollable">{children}</div>
        </LayoutContainer> */}
      </Container>
    </StyledLayout>
  );
};
